import React from "react";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import ReportForm from "../Report/ReportForm.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";

const ReportAction = ({ tooltipDisabled }) => {
  const { setModal } = useModal();
  const setReport = () => setModal(ReportForm);

  return !tooltipDisabled ? (
    <Tooltip
      id={"reportActionIcon"}
      tooltipTextKey="report-icon-tooltip-text"
      top
    >
      <Icon name="warning" onClick={setReport} gray />
    </Tooltip>
  ) : (
    <Icon name="warning" onClick={setReport} gray />
  );
};

export default ReportAction;
